import type {ReactElement} from 'react';
import {COUNTDOWN_UNIT_ORDER} from '@EmailMakerReact/lib/email-maker-countdown-library.types';
import type {EmailMakerControlProps} from '../../right-panel-registry.types';
import {CountdownLabelField} from './components/countdown-label-field/countdown-label-field';
import styles from './countdown-labels-control.module.scss';

export function CountdownLabelsControl({component}: EmailMakerControlProps): ReactElement {
  return (
    <div className={styles.wrapper}>
      {COUNTDOWN_UNIT_ORDER.map((unit) => (
        <CountdownLabelField component={component} key={unit} unit={unit} />
      ))}
    </div>
  );
}
